export const parseQRCodeTagId = (string: string): string => {
  if (!string) return ''
  const s = string.trim()
  if (!s) return ''
  return s
    .toString()
    .replace(/(0*)([1-9][0-9]*)(;U....[0-9]{4}([-][0-9]{2})?)/, '$2')
}
